import { useEffect } from 'react';
import throttle from 'lodash/throttle';

const useKeydownHandler = (ref, onKeydown, LISTENER_THROTTLE = 100) => {
  useEffect(() => {
    const throttledHandleKeydown = throttle((e) => {
      if (e.key === 'Enter' || e.key === ' ') {
        e.preventDefault();
        onKeydown?.();
      }
    }, LISTENER_THROTTLE);

    if (typeof document !== 'undefined' && ref.current) {
      // add listeners on Mount
      ref.current.addEventListener('keydown', throttledHandleKeydown);
    }

    return () => {
      if (typeof document !== 'undefined' && ref.current) {
        // remove listeners on Unmount
        ref.current.removeEventListener('keydown', throttledHandleKeydown);
      }
      throttledHandleKeydown.cancel(); // cancel any pending throttled calls
    };
  }, [ref, onKeydown, LISTENER_THROTTLE]);
};

export default useKeydownHandler;
